define('C3.ShoppingExtensions.PDP.ContactForPricing.View'
  , [
    'c3_shoppingextensions_contactforpricing_view.tpl',
    'Profile.Model',
    'Utils',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.Countries.View',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.States.View',
    'Backbone.View',
    'C3.ShoppingExtensions.PDP.ContactForPricing.Model',
    'Backbone.FormView',
    'GlobalViews.Message.View',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.CustomerCategory.Model',
    'AjaxRequestsKiller'
  ],
  function (
    c3_shoppingextensions_contactforpricing_view_tpl,
    ProfileModel,
    Utils,
    CountriesView,
    StatesView,
    BackboneView,
    C3ShoppingExtensionsPDPContactForPricingModel,
    BackboneFormView,
    GlobalViewsMessageView,
    CustomerCategoryModel,
    AjaxRequestsKiller
  ) {
    'use strict';
    return Backbone.View.extend({

      template: c3_shoppingextensions_contactforpricing_view_tpl,

      initialize: function (options) {
        this.options = options;
        this.configuration = options.configuration

        this.countries = this.configuration.get('siteSettings.countries', []);

        var profile = ProfileModel.getInstance()
          , is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

        if (is_logged_in) {
          var addressBook = profile.get('addressbook');

          var find_shippingAddr = _.findWhere(addressBook, {
            defaultshipping: 'T'
          });

          if (find_shippingAddr) {
            this.loggedUserCountry = find_shippingAddr.country
            this.loggedUserState = find_shippingAddr.state
          }
        }

        this.model = new C3ShoppingExtensionsPDPContactForPricingModel();
        this.model.on('save', _.bind(this.redirect, this));


        var self = this;
        var profile = ProfileModel.getInstance()
          , is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

        if (is_logged_in) {
          var customerid = profile.get('internalid')
          var customerCategory = new CustomerCategoryModel();
          customerCategory.fetch({
            data: {
              customerid: customerid
            },
            killerId: AjaxRequestsKiller.getKillerId()
          }).done(function (res) {

            var responseData = res.customercategory
            self.customerCategory = responseData;
            //console.log(responseData)
            $("#in-modal-ima").val(responseData).change()
            //self._render();
          });
        }

        BackboneFormView.add(this);
        //this.page_domain = window.location.origin;
        //this.page_domain= this.page_domain+"/api/items?fieldset=details&q="+this.options.itemid;
        //console.log('initialize')

      },

      events: {
        'change [data-action="selectcountry"]': 'updateStates',
        'submit form': 'submitForm'
      },

      bindings: {
        '[name="firstname"]': 'firstname',
        '[name="lastname"]': 'lastname',
        '[name="company"]': 'company',
        '[name="phone"]': 'phone',
        '[name="email"]': 'email',
        '[name="language"]': 'language',
        '[name="ima"]': 'ima',
        /*'[name="state"]': 'state',*/
        '[name="country"]': 'country'
      },

      /*render: function(){
      	
  
        //this._render();
      },*/

      redirect: function (context, response) {

        var responseData = response.responseData
          , parseResponseData = JSON.parse(responseData)
          , responseStatus = parseResponseData.responseStatus
          , message = ''
          , type = ''

        if (parseResponseData) {
          if (responseStatus == "Success") {
            message = "You've successfully submitted the request."
            type = 'success'
          } else {
            message = "An error occured while submitting the request."
            type = 'warning'
          }
          //var message = "You've successfully submitted the request."
          var $alert_placeholder = $('.make-an-offer-msg-placeholder');
          var alert = new GlobalViewsMessageView({
            message: message,
            type: type,
            closable: true
          });
          alert.show($alert_placeholder, 10000);

          //console.log(responseStatus)
        }
      },

      submitForm: function (e, model, props) {
        e.preventDefault();

        var self = this;
        var data = (jQuery(e.target).closest('form')).serializeObject();
        console.log(data)
        return this.cancelableTrigger('before:C3.ShoppingExtensions.PDP.ContactForPricing', data).then(function () {
          self.saveForm(e, model, props);
        });
      },

      childViews: {
        'Countries.View': function () {
          //console.log(this.loggedUserCountry)
          if (this.loggedUserCountry)
            this.selectedCountry = this.loggedUserCountry;

          return new CountriesView({
            countries: this.countries,
            selectedCountry: this.selectedCountry,
            manage: this.options.manage
          });
        },
        'States.View': function () {
          //console.log(this.loggedUserState)
          if (this.loggedUserState)
            this.selectedState = this.loggedUserState;

          if (this.loggedUserCountry)
            this.selectedCountry = this.loggedUserCountry;

          return new StatesView({
            countries: this.countries,
            selectedCountry: this.selectedCountry,
            selectedState: this.selectedState,
            manage: this.manage
          });
        }
      }

      , updateStates: function (e) {
        var statesView = this.getChildViewInstance('States.View');
        var selectedCountry = this.$(e.currentTarget).val();

        var self = this;

        var find_country = _.findWhere(self.countries, {
          name: selectedCountry
        });

        //console.log(this.selectedCountry)

        //this.selectedCountry = '';

        if (find_country) {
          statesView.options.selectedCountry = find_country.code;
          this.selectedCountry = find_country.code;
          statesView.render();
        }
        //console.log(this.selectedCountry)
      }

      , getContext: function getContext() {
        var profile = ProfileModel.getInstance()
          , is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
          , loggedUserFirstName = ''
          , loggedUserLastName = ''
          , loggedUserEmail = ''
          //, 	loggedUserCountry = ''
          //,   loggedUserState = ''
          , loggedUserCompany = ''
          , loggedUserPhone = ''
          , self = this

        if (is_logged_in) {
          loggedUserFirstName = profile.get('firstname')
          loggedUserLastName = profile.get('lastname')
          loggedUserEmail = profile.get('email')
          loggedUserCompany = profile.get('companyname')
          //console.log(profile)

          var PhoneInfo = profile.get('phoneinfo');
          loggedUserPhone = PhoneInfo.phone;

        }

        var makeAnOfferConfgn = this.configuration.PDPMakeAnOffer
          , makeAnOfferConfig = makeAnOfferConfgn.config
          , makeAnOfferSalesRepConfgn = this.configuration.PDPMakeAnOfferSalesRep
          , makeAnOfferSalesRepConfig = makeAnOfferSalesRepConfgn.config


        _.each(makeAnOfferConfig, function (salesrep) {
          if (salesrep.customercategoryid == self.customerCategory)
            salesrep.isSelected = true;
        });

        //console.log(makeAnOfferConfig)

        return {
          itemsku: this.options.itemid,
          itemname: this.options.itemname,
          itemInternalId: this.options.internalid,
          isLoggedIn: is_logged_in,
          loggedUserFirstName: loggedUserFirstName,
          loggedUserLastName: loggedUserLastName,
          loggedUserEmail: loggedUserEmail,
          loggedUserCompany: loggedUserCompany,
          loggedUserPhone: loggedUserPhone,
          makeAnOfferConfig: makeAnOfferConfig,
          makeAnOfferSalesRepConfig: makeAnOfferSalesRepConfig,
          selectedCustomerCategory: this.customerCategory,
          safariBrowserMac: (typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1) ? true : false
        };
      }
    });
  });
